import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import template from 'lodash/template';
import phrasesType from '../proptypes/phrases';
import profileWithArchetypeType from '../proptypes/profile-with-archetype';
import AccountLayout from '../layouts/AccountLayout';
import PageSection from '../components/PageSection';
import PageHeading from '../components/PageHeading';
import InviteForm from '../components/invite-friends/InviteForm';
import ComparisonPreviewTable from '../components/ComparisonPreviewTable';
import { mediaBreakpointUpLG } from '../constants/style-constants';

const previewProfile = {
  profile: {
    id: 'bourne',
    fullName: 'Jason Bourne',
    email: null,
  },
  archetype: {
    id: 'special_ops',
    name: 'Special Ops Officer',
    percentage: 95,
  },
  attributes: {
    agility: 10,
    coldRisk: 9,
    composure: 10,
    conscientiousness: 9,
    hotRisk: 8,
    inquisitiveness: 9,
    interpersonalSkills: 6,
    mentalHorsepower: 9,
    observation: 9,
    sociability: 6,
  },
};

const selectPageTitle = (
  { comparison: { previewUserPageTitle } },
  { profile: { fullName } },
) => template(previewUserPageTitle)({ name: fullName });

const FadedContentPreview = styled.div`
  overflow: hidden;
  position: relative;
  height: 360px;

  ${mediaBreakpointUpLG} {
    height: 280px;
  }

  &::after {
    background:
      linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.15) 55%,
        rgba(0, 0, 0, 1) 100%
      );
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const PreviewComparisonPage = ({
  currentProfile,
  phrases,
  urls: { referralUrl },
}) => (
  <AccountLayout>
    <PageSection theme="black">
      <PageHeading title={selectPageTitle(phrases, previewProfile)} />
      <FadedContentPreview>
        <ComparisonPreviewTable
          currentProfile={currentProfile}
          comparedProfile={previewProfile}
          phrases={phrases}
        />
      </FadedContentPreview>
      <InviteForm
        phrases={phrases.inviteFriends}
        referralUrl={referralUrl}
      />
    </PageSection>
  </AccountLayout>
);

PreviewComparisonPage.propTypes = {
  currentProfile: profileWithArchetypeType.isRequired,
  phrases: phrasesType.isRequired,
  urls: PropTypes.shape({
    referralUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default PreviewComparisonPage;
